export const INSERT_POLL_MODAL_ID = 'POLL.insert';
export const POLL_SETTINGS_MODAL_ID = 'POLL.settings';
export const POLL_SETTINGS_DESIGN_MODAL_ID = 'POLL.design';
export const POLL_LAYOUT_DROPDOWN_MODAL_ID = 'POLL.layoutDropdown';

export const SETTINGS_TAB = {
  layout: 'layout',
  design: 'design',
  settings: 'settings',
} as const;

export type SettingsType = (typeof SETTINGS_TAB)[keyof typeof SETTINGS_TAB];
